import { render, staticRenderFns } from "./BrokerDrawer.vue?vue&type=template&id=80c38e02&"
import script from "./BrokerDrawer.vue?vue&type=script&lang=js&"
export * from "./BrokerDrawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports